define('OutSystems/ClientRuntime/JSONUtils',["require", "exports", "./DataConversion", "./Settings"], function (require, exports, DataConversion_1, Settings_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.mergeJS = exports.parseJSON = exports.filterJSONValues = exports.deserializeFromJSON = exports.serializeToJSON = void 0;
    function serializeToJSON(value, serializeDefaultValues, useUnixDateFormat, valueType) {
        var convertedJSON = (0, Settings_1.getEnvParams)().UseNewJSONSerialization
            ? DataConversion_1.NewJSONConverter.to({
                value: value,
                serializeDefaultValues: serializeDefaultValues,
                useUnixDateFormat: useUnixDateFormat,
                dataType: valueType,
                enforceDefaultValueSerializationAtThisLevel: true,
            })
            : DataConversion_1.JSONConverter.to(value, serializeDefaultValues, useUnixDateFormat, valueType);
        return JSON.stringify(convertedJSON, filterJSONValues);
    }
    exports.serializeToJSON = serializeToJSON;
    function deserializeFromJSON(json, valueType, useUnixDateFormat) {
        try {
            var objrepr = void 0;
            if (json) {
                objrepr = parseJSON(json);
            }
            return DataConversion_1.JSONConverter.from(objrepr, valueType, useUnixDateFormat);
        }
        catch (e) {
            throw "Failed to deserialize JSON to " + valueType.name + ": " + e.message;
        }
    }
    exports.deserializeFromJSON = deserializeFromJSON;
    function filterJSONValues(key, value) {
        if (value === null) {
            return undefined;
        }
        return value;
    }
    exports.filterJSONValues = filterJSONValues;
    function parseJSON(json) {
        var rx = /(?:"([^\\"]|\\.)*")|(?:'([^\\']|\\.)*')|(-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)|(\w+)\s*:/g;
        var cleanJSON = json.replace(rx, function (match, dqString, sqString, numbers, unquoted) {
            if (numbers) {
                return '"' + numbers + '"';
            }
            if (sqString) {
                return '"' + match.substring(1, match.length - 1) + '"';
            }
            if (unquoted) {
                return '"' + unquoted + '":';
            }
            return match;
        });
        return JSON.parse(cleanJSON);
    }
    exports.parseJSON = parseJSON;
    function mergeJS(target, source) {
        var targetAttr, sourceAttr, copyIsArray, cloneAttr;
        for (var name_1 in source) {
            targetAttr = target[name_1];
            sourceAttr = source[name_1];
            var mergingPlainObjectsOrArrays = sourceAttr && targetAttr && (typeof sourceAttr === "object" || (copyIsArray = Array.isArray(sourceAttr)));
            if (mergingPlainObjectsOrArrays) {
                if (copyIsArray) {
                    copyIsArray = false;
                    cloneAttr = Array.isArray(targetAttr) ? targetAttr : [];
                }
                else {
                    cloneAttr = typeof targetAttr === "object" ? targetAttr : {};
                }
                target[name_1] = mergeJS(cloneAttr, sourceAttr);
            }
            else if (sourceAttr !== undefined) {
                target[name_1] = sourceAttr;
            }
        }
        return target;
    }
    exports.mergeJS = mergeJS;
});
//# sourceMappingURL=JSONUtils.js.map;
